import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Container,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  useBreakpointValue,
  useDisclosure,
} from '@chakra-ui/react';
import { useClaim } from 'core';
import { PropsWithChildren } from 'react';
import {
  FiActivity,
  FiBarChart,
  FiCompass,
  FiDollarSign,
  FiFlag,
  FiPenTool,
  FiSearch,
  FiSettings,
} from 'react-icons/fi';
import { NavLink } from 'react-router-dom';
import { ColorModeButton } from '../components';
import { SideBar } from './SideBar';
import { ToggleButton } from './ToggleButton';

const NavButton = (
  props: PropsWithChildren<{ icon?: JSX.Element; path: string }>
) => {
  const { icon, children, path } = props;

  return (
    <NavLink to={path}>
      {({ isActive }) => (
        <Button
          className={isActive ? 'active' : ''}
          aria-current={isActive ? 'page' : undefined}
          leftIcon={icon}
        >
          {children}
        </Button>
      )}
    </NavLink>
  );
};
export const Navbar = () => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const { isOpen, onToggle, onClose } = useDisclosure();

  const isAdmin = useClaim('ca', '1');

  return (
    <Box as="nav" bg="bg-surface" boxShadow="sm">
      <Container py={{ base: '3', lg: '4' }} minWidth={'100%'}>
        <Flex justify="space-between">
          <HStack spacing="4">
            {/* <Logo /> */}
            {isDesktop && (
              <ButtonGroup variant="ghost" spacing="1">
                <NavButton icon={<FiBarChart />} path="dashboard">
                  Dashboard
                </NavButton>
                {/* <NavButton path="board-projects">Board Projects</NavButton> */}
                <NavButton icon={<FiActivity />} path="cqtt">
                  CQTT's
                </NavButton>
                <NavButton icon={<FiFlag />} path="afes">
                  AFE's
                </NavButton>
                <NavButton icon={<FiPenTool />} path="purchase-orders">
                  Purchase Orders
                </NavButton>
                <NavButton icon={<FiCompass />} path="work-orders">
                  Work Orders
                </NavButton>
                <NavButton icon={<FiDollarSign />} path="invoices">
                  Invoices
                </NavButton>
                {isAdmin && (
                  <NavButton icon={<FiSettings />} path="client-settings">
                    Settings
                  </NavButton>
                )}
              </ButtonGroup>
            )}
          </HStack>
          {isDesktop ? (
            <HStack spacing="4">
              <ColorModeButton />
              <ButtonGroup variant="ghost" spacing="1">
                <IconButton
                  icon={
                    // @ts-ignore
                    <FiSearch fontSize="1.25rem" />
                  }
                  aria-label="Search"
                />
                <IconButton
                  icon={
                    // @ts-ignore
                    <FiSettings fontSize="1.25rem" />
                  }
                  aria-label="Settings"
                />
                {/* <IconButton
                  icon={<FiHelpCircle fontSize="1.25rem" />}
                  aria-label="Help Center"
                /> */}
              </ButtonGroup>
              <Avatar
                boxSize="10"
                name="Christoph Winston"
                src="https://tinyurl.com/yhkm2ek8"
              />
            </HStack>
          ) : (
            <>
              <ToggleButton
                isOpen={isOpen}
                aria-label="Open Menu"
                onClick={onToggle}
              />
              <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                isFullHeight
                preserveScrollBarGap
                // Only disabled for showcase
                trapFocus={false}
              >
                <DrawerOverlay />
                <DrawerContent>
                  <SideBar />
                </DrawerContent>
              </Drawer>
            </>
          )}
        </Flex>
      </Container>
    </Box>
  );
};
